'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["agentMemoState", "isAgentMemoOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GET_AGENT_MEMOS, MemoModalVariants } from '@whitbread-eos/api';
import React, { useContext, useState } from 'react';
import { useQueryRequest } from '../hooks';
import noop from '../utils/noop';
import { jsx as _jsx } from "react/jsx-runtime";
export var AgentMemoContext = React.createContext({
  isAgentMemoOpen: false,
  openAgentMemo: noop,
  closeAgentMemo: noop,
  setAgentMemoReservationId: noop,
  agentMemoState: {
    reservationId: '',
    variant: ''
  },
  user: {}
});
export function useAgentMemo() {
  var _agentMemoData$memos;
  var _useContext = useContext(AgentMemoContext),
    agentMemoState = _useContext.agentMemoState,
    isAgentMemoOpen = _useContext.isAgentMemoOpen,
    rest = _objectWithoutProperties(_useContext, _excluded);
  var _useQueryRequest = useQueryRequest(['GetAgentMemos', agentMemoState.reservationId], GET_AGENT_MEMOS, {
      basketReference: agentMemoState.reservationId
    }, {
      enabled: !!agentMemoState.reservationId,
      select: data => {
        return data.getMemos || data.createMemo;
      },
      onError: error => {
        console.log(error);
      }
    }, undefined, !!'returnError'),
    agentMemoData = _useQueryRequest.data;
  return _objectSpread({
    agentMemoData,
    agentMemoCount: agentMemoData === null || agentMemoData === void 0 || (_agentMemoData$memos = agentMemoData.memos) === null || _agentMemoData$memos === void 0 ? void 0 : _agentMemoData$memos.length,
    agentMemoState,
    isAgentMemoOpen
  }, rest);
}
export function AgentMemoProvider(_ref) {
  var children = _ref.children,
    user = _ref.user;
  var defaultState = {
    reservationId: '',
    variant: MemoModalVariants.PAGE
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAgentMemoOpen = _useState2[0],
    setIsAgentMemoOpen = _useState2[1];
  var _useState3 = useState(defaultState),
    _useState4 = _slicedToArray(_useState3, 2),
    agentMemoState = _useState4[0],
    setAgentMemoState = _useState4[1];
  var setAgentMemoReservationId = reservationId => {
    setAgentMemoState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      reservationId
    }));
  };
  var openAgentMemo = variant => {
    setAgentMemoState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      variant
    }));
    setIsAgentMemoOpen(true);
  };
  var closeAgentMemo = () => {
    if (agentMemoState.variant === MemoModalVariants.CARD) {
      setAgentMemoState(defaultState);
    }
    setIsAgentMemoOpen(false);
  };
  var value = {
    isAgentMemoOpen,
    openAgentMemo,
    closeAgentMemo,
    agentMemoState,
    setAgentMemoReservationId,
    user
  };
  return _jsx(AgentMemoContext.Provider, {
    value: value,
    children: children
  });
}